import {Injectable} from '@angular/core';
import {MediaObjectRestService} from "../../api/services/media-object.rest.service";
import {BehaviorSubject, forkJoin, Observable, of, shareReplay} from "rxjs";
import {MediaObjectApiModel} from "../../api/models/media-object.api-model";
import {filter, take, tap} from "rxjs/operators";
import {FileRestService} from "../../api/services/file.rest.service";

@Injectable({
  providedIn: 'root',
})
export class MediaUploadService {

  public files: File[] = [];
  public newFiles: File[] = [];
  constructor(
    private readonly mediaObjectRS: MediaObjectRestService,
    private readonly frs: FileRestService,
  ) {}

  uploadMedia(
    files: File[]
  ): Observable<{
    mediaObjects$: Observable<MediaObjectApiModel[]>;
    progress$: Observable<number>;
  }> {
    const progress$ = new BehaviorSubject<number>(0);

    if (!files.length) {
      progress$.next(100);
      progress$.complete();

      return of({
        mediaObjects$: of([]),
        progress$: progress$.asObservable(),
      });
    }

    const totalFiles = files.length;
    const perFileProgress = Array(totalFiles).fill(0);

    const uploads$ = files.map((file, index) =>
      this.mediaObjectRS.uploadImage(file).pipe(
        tap(value => {
          if (typeof value === 'number') {
            perFileProgress[index] = value;
            const total =
              perFileProgress.reduce((a, b) => a + b, 0) / totalFiles;
            progress$.next(Math.round(total));
          }
        }),
        filter(
          (value): value is MediaObjectApiModel =>
            typeof value !== 'number'
        ),
        take(1)
      )
    );

    const mediaObjects$ = forkJoin(uploads$).pipe(
      tap(() => {
        progress$.next(100);
        progress$.complete();
      }),
      shareReplay(1)
    );

    return of({
      mediaObjects$,
      progress$: progress$.asObservable(),
    });
  }

  convertUrlToFile(fileUrls: string[]): Observable<File[]> {
    console.log(fileUrls);
    const requests: Observable<File>[] = [];
    for (const url of fileUrls) {
      // arr.push(new File([await (await fetch(url)).blob()], url, {type: 'image/jpeg'}));
      requests.push(this.frs.getFile(url).pipe(tap(file => {
        if (!this.files.find(f => f.name == file.name)) {
          this.files.push(file);
        }
      })));
    }

    if (!requests.length) {
      this.files = [...this.newFiles];
      return of(this.files);
    }

    return forkJoin(requests);
  }
}


